import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
        
export default function cursoconstanciaReducer(state= initialState.cursoconstancia, action){
    let newState;
	switch(action.type){
         case types.LOAD_CURSOCONSTANCIA_LIST_SUCCESS:		
            action.cursoconstancia.filtroActivo=state.filtroActivo;
            action.cursoconstancia.filtroActual=state.filtroActual;
            action.cursoconstancia.showActivos=state.showActivos;
			 action.cursoconstancia.paginaActual=action.cursoconstancia.pageable.pageNumber;
			 action.cursoconstancia.registrosPorPagina=action.cursoconstancia.size;
            
            return action.cursoconstancia;

        case types.BORRAR_CURSOCONSTANCIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoconstancia => cursoconstancia.id !== action.cursoconstancia.id)];          
			return newState;    
            
        case types.ACTIVAR_CURSOCONSTANCIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoconstancia => cursoconstancia.id !== action.cursoconstancia.id)];          
			 return newState;
            
        case types.SET_FILTRO_CURSOCONSTANCIA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}